import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthService } from './pages/shared/auth.service';
import { AuthGuard } from './pages/shared/auth-guard.service';
import { MakerService } from './pages/shared/maker.service';
import { TakerService } from './pages/shared/taker.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LocationService } from './shared/locations/location.service';
import { ActivitiesService } from './pages/activities/activities.service';
import { CategoriesService } from './shared/categories/categories.service';
import { TagsService } from './shared/tags/tags.service';
import { UsersService } from './shared/users/users.service';
import { CountryService } from './shared/locations/country.service';
import { MediaActivitiesService } from './pages/activities/media-activities.service';
import { JsonLdService } from './json-ld.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideHttpClient(withFetch()),
    provideAnimations(),
    // provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    // importProvidersFrom(MatNativeDateModule),
    DatePipe,
    AuthService,
    AuthGuard,
    MakerService,
    TakerService,
    BsModalService,
    LocationService,
    ActivitiesService,
    CategoriesService,
    TagsService,
    UsersService,
    CountryService,
    MediaActivitiesService,
    JsonLdService,
  ],
};
